export default __webpack_public_path__ + "static/media/Tool.83a0001b.svg";